export enum CallbackTableState {
  MODIFICA = 'MODIFICA',
  DELETE = 'DELETE',
  STAMPA = 'STAMPA',
  VALIDA = 'VALIDA',
  SINGLE = 'SINGLE',
  DOUBLE = 'DOUBLE',
  CLICKCELL = 'CLICKCELL',
  EXCEL = 'EXCEL',
  PDF = 'PDF',
  FOTO = 'FOTO',
  FILTER = 'FILTER',
  NUOVO = 'NUOVO',
  AGGIORNA = 'AGGIORNA',
  DOWNLOAD = 'DOWNLOAD',
  DETTAGLIO = 'DETTAGLIO',
  CONTESTA = 'CONTESTA',
  CREA = 'CREA',
  FUNCTION = 'FUNCTION',
  CHIUDI = 'CHIUDI',
  VALUE = 'VALUE',
  CHILD = 'CHILD',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}
